const initialState = {
  viewList: null,
  reportList: null,
};

export default function viewReportData(state = initialState, action: any) {
  switch (action.type) {
    case "SET_VIEW_LIST":
      const viewList = action.payload;
      return {
        ...state,
        viewList,
      };
    case "SET_REPORT_LIST":
      const reportList = action.payload;
      return {
        ...state,
        reportList,
      };
    case "REMOVE_VIEW_LIST":
      return { ...initialState };

    case "REMOVE_REPORT_LIST":
      return { ...initialState };
    default:
      return state;
  }
}
